import React from 'react';
import { DataTable } from '../../../../../ui';
import { getColumns } from './Functions';
import { useAssessmentTab } from './Hooks';

interface IAssessmentTabProps {
  searchTerm?: string;
}

export const AssesmentTab = ({ searchTerm }: IAssessmentTabProps) => {
  const {
    data,
    loading,
    pageNumber,
    totalPages,
    onPageChange,
    handleOnClick,
    totalRecords,
  } = useAssessmentTab(searchTerm);

  return (
    <div className='relative w-full'>
      <DataTable
          isLoading={loading}
          columns={getColumns}
          data={data}
          rowsPerPage={5}
          onPageChange={onPageChange}
          currentPage={pageNumber}
          totalPages={totalPages}
          onClickRow={(row) => {
            handleOnClick(row['id']);
          }}
          totalRecords={totalRecords}
      />
    </div>
  );
};
